//Constants related to followers/follows
export const GET_FOLLOWING_LIST = 'GET_FOLLOWING_LIST'
export const GET_FOLLOWERS_LIST = 'GET_FOLLOWERS_LIST'
export const GET_FOLLOWING_LIST_WAIT = 'GET_FOLLOWING_LIST_WAIT'
export const UNFOLLOW = 'UNFOLLOW'
export const ADD_FOLLOW = 'ADD_FOLLOW'
export const GET_FOLLOWING_FOR_USER = 'GET_FOLLOWING_FOR_USER'
export const GET_FOLLOWERS_FOR_USER = 'GET_FOLLOWERS_FOR_USER'
export const GET_SEARCH = 'GET_SEARCH'
